import { Marker } from "react-map-gl/maplibre"
import { Box, Text } from "@chakra-ui/react"

interface ClusterMarkerProps {
  latitude: number
  longitude: number
  pointCount: number
  onClick: () => void
  highestSeverity?: string | null
}

function ClusterMarker({ latitude, longitude, pointCount, onClick, highestSeverity }: ClusterMarkerProps) {
  // Size cluster based on point count
  const size = pointCount < 10 ? 40 : pointCount < 100 ? 50 : 60
  const fontSize = pointCount < 10 ? "12px" : pointCount < 100 ? "14px" : "16px"

  // Color based on highest severity in cluster
  const severityColors = {
    critical: "#dc2626", // red
    warning: "#d97706",  // amber
    info: "#3b82f6",     // blue
    healthy: "#059669",  // green
  }

  const color = highestSeverity && severityColors[highestSeverity as keyof typeof severityColors]
    ? severityColors[highestSeverity as keyof typeof severityColors]
    : "#6b7280" // gray for no alerts

  return (
    <Marker
      latitude={latitude}
      longitude={longitude}
      onClick={(e) => {
        e.originalEvent.stopPropagation()
        onClick()
      }}
    >
      <Box
        width={`${size}px`}
        height={`${size}px`}
        borderRadius="50%"
        bg={color}
        border="3px solid white"
        display="flex"
        alignItems="center"
        justifyContent="center"
        cursor="pointer"
        boxShadow={`0 4px 20px ${color}66`}
        transition="transform 0.2s ease"
        _hover={{ transform: "scale(1.1)" }}
      >
        <Text
          fontSize={fontSize}
          fontWeight="700"
          color="white"
        >
          {pointCount}
        </Text>
      </Box>
    </Marker>
  )
}

export default ClusterMarker